import { actionCreator } from './../actions/actions';
// todo: type the any payloads
export const SetReceiptAction = 'SetReceiptAction';
export const createSetReceiptAction = actionCreator(SetReceiptAction);
export const SetBillingAddressAction = 'SetBillingAddressAction';
export const createSetBillingAddressAction = actionCreator(SetBillingAddressAction);
export const SetCheckoutId = 'SetCheckoutId';
export const createSetCheckoutId = actionCreator(SetCheckoutId);
export const SetActiveStep = 'SetActiveStep';
export const createSetActiveStep = actionCreator(SetActiveStep);
export const SetProduct = 'setProduct';
export const createProduct = actionCreator(SetProduct);
export const SetBillingTerm = 'SetBillingTerm';
export const createSetBillingTerm = actionCreator(SetBillingTerm);
export const SetTermId = 'SetTermId';
export const createSetTermId = actionCreator(SetTermId);
export const SetSeatNumber = 'SetSeatNumber';
export const createSetSeatNumber = actionCreator(SetSeatNumber);
export const SetRecurringBilling = 'SetRecurringBilling';
export const createSetRecurringBilling = actionCreator(SetRecurringBilling);
export const SetItemInCartAction = 'SetItemInCartAction';
export const createSetItemInCartAction = actionCreator(SetItemInCartAction);
export const SetCheckoutSource = 'SetCheckoutSource';
export const createSetCheckoutSource = actionCreator(SetCheckoutSource);
export const UpdateCustomerAction = 'UpdateCustomerAction';
export const createUpdateCustomerAction = actionCreator(UpdateCustomerAction);
export const SetCustomersAction = 'SetCustomersAction';
export const createSetCustomersAction = actionCreator(SetCustomersAction);
export const SetActiveCustomerAction = 'SetActiveCustomerAction';
export const createSetActiveCustomerAction = actionCreator(SetActiveCustomerAction);
export const SetPublisherTokenResponse = 'SetPublisherTokenResponse';
export const createSetPublisherTokenResponse = actionCreator(SetPublisherTokenResponse);
// eslint-disable-next-line @typescript-eslint/ban-types
export const ClearCheckoutState = 'ClearCheckoutState';
export const createClearCheckoutState = actionCreator(ClearCheckoutState);
export const ClearErrorAction = 'ClearErrorAction';
export const createClearErrorAction = actionCreator(ClearErrorAction);
export const ErrorAction = 'ErrorAction';
export const createErrorAction = actionCreator(ErrorAction);
export const FetchingProductAction = 'FetchingProductAction';
export const createFetchingProductAction = actionCreator(FetchingProductAction);
